import React from "react";
import { Check, ShieldCheck, BookOpen, FileText, Award, Eye } from "lucide-react";

const BADGES = [
  {
    id: "ai-reviewed",
    label: "AI Reviewed",
    icon: Eye,
    earned: (t) => t.evidence_score != null || t.source_quality_score != null || t.consensus_score != null,
  },
  {
    id: "sources-verified",
    label: "Sources Verified",
    icon: ShieldCheck,
    earned: (t) => (t.sources?.length ?? 0) >= 3,
  },
  {
    id: "editor-approved",
    label: "Editor Approved",
    icon: Award,
    earned: (t) => t.editor_approved === true,
  },
  {
    id: "primary-sources",
    label: "Primary Sources Included",
    icon: FileText,
    earned: (t) => (t.sources || []).some((s) => s.stance === "primary"),
  },
  {
    id: "academic-sources",
    label: "Academic Sources Included",
    icon: BookOpen,
    earned: (t) => (t.sources || []).some((s) => s.stance === "academic" || s.stance === "book"),
  },
];

export const TrustBadges = ({ topic, dense = false }) => {
  const earned = BADGES.filter((b) => b.earned(topic));
  if (earned.length === 0) return null;
  return (
    <div
      className={`flex flex-wrap gap-2 ${dense ? "" : "mt-4"}`}
      data-testid="trust-badges"
    >
      {earned.map((b) => (
        <span
          key={b.id}
          data-testid={`badge-${b.id}`}
          className="inline-flex items-center gap-1.5 border border-[#5DD4B3]/30 bg-[#5DD4B3]/5 text-[#5DD4B3] px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.2em]"
        >
          <Check size={10} strokeWidth={3} />
          <b.icon size={10} />
          <span>{b.label}</span>
        </span>
      ))}
    </div>
  );
};

export default TrustBadges;
